"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Box_1 = require("@mui/material/Box");
const ArrowForwardIosRounded_1 = require("@mui/icons-material/ArrowForwardIosRounded");
const DiscountIcon_1 = require("../../assets/icons/DiscountIcon");
const CardButton_styles_1 = require("./CardButton.styles");
const CardButton = ({ greenStyle, cardContent, actionButton, single, disabled }) => {
    const { container } = (0, CardButton_styles_1.default)({
        greenStyle,
        single,
        disabled,
    });
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { sx: container, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(DiscountIcon_1.default, { color: disabled ? theme.qlub.palette.onSurfaceColors.disabled : '#1A1C23' }) }), (0, jsx_runtime_1.jsx)("div", { children: cardContent })] }), (0, jsx_runtime_1.jsx)("div", { children: actionButton ||
                    (!greenStyle && ((0, jsx_runtime_1.jsx)(material_1.IconButton, { children: (0, jsx_runtime_1.jsx)(ArrowForwardIosRounded_1.default, {}) }))) })] }));
};
exports.default = CardButton;
